import { render, staticRenderFns } from "./ComUseAgreement.vue?vue&type=template&id=64226039&"
import script from "./ComUseAgreement.vue?vue&type=script&lang=js&"
export * from "./ComUseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ComUseAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports